export enum SortOrder {
  Ascending = 1,
  Descending = -1,
  None = 0,
}

export declare interface SortDescriptor {
  fieldname: string;
  order: SortOrder;
}
